var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { API } from './api';
import { ClassProvider } from './class';
import { BaseProvider } from './base';
import { BRAIN_ACCURACY_DESCRIPTORS } from '../components/workspace/accuracy/constants';
import { DownloadProvider } from './download';
import { JobType } from './job';
import { TrackableJobProvider } from './trackable-job';
import { TranslateService } from '@ngx-translate/core';
var BrainHistory = /** @class */ (function () {
    function BrainHistory() {
    }
    return BrainHistory;
}());
export { BrainHistory };
var BrainDetails = /** @class */ (function () {
    function BrainDetails() {
    }
    return BrainDetails;
}());
export { BrainDetails };
// Overwrites the possibly undefined properties in the base interface
var DetectionBrainEnvironmentStats = /** @class */ (function (_super) {
    __extends(DetectionBrainEnvironmentStats, _super);
    function DetectionBrainEnvironmentStats() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DetectionBrainEnvironmentStats;
}(BrainDetails));
export { DetectionBrainEnvironmentStats };
export var BrainEnvironmentName;
(function (BrainEnvironmentName) {
    BrainEnvironmentName["Current"] = "current";
    BrainEnvironmentName["CurrentFrozen"] = "currentFrozen";
    BrainEnvironmentName["Staging"] = "staging";
    BrainEnvironmentName["Production"] = "production";
    BrainEnvironmentName["AnomalyHiFi"] = "anomalyHiFi";
})(BrainEnvironmentName || (BrainEnvironmentName = {}));
var BrainEnvironments = /** @class */ (function () {
    function BrainEnvironments() {
    }
    return BrainEnvironments;
}());
export { BrainEnvironments };
var Brain = /** @class */ (function () {
    function Brain() {
    }
    Brain.prototype.getFormattedAccuracy = function () {
        return Math.round(this.accuracy * 100) + "%";
    };
    return Brain;
}());
export { Brain };
var BrainClass = /** @class */ (function () {
    function BrainClass() {
    }
    return BrainClass;
}());
export { BrainClass };
var BrainEnvClass = /** @class */ (function () {
    function BrainEnvClass() {
    }
    return BrainEnvClass;
}());
export { BrainEnvClass };
export var BrainVersionType;
(function (BrainVersionType) {
    BrainVersionType["Learning"] = "Learning";
    BrainVersionType["Frozen"] = "Frozen";
    BrainVersionType["Custom"] = "Custom";
    BrainVersionType["AnomalyHiFi"] = "AnomalyHiFi";
})(BrainVersionType || (BrainVersionType = {}));
export var BrainVersionDisplayInfoMap = {
    'Anomaly Recognition': {
        Learning: { label: 'Anomaly Recognizer', icon: 'tonality' },
        AnomalyHiFi: { label: 'Anomaly Hi-Fi', icon: 'lens_blur' }
    },
    'Scene Recognition': {
        Learning: { label: 'Learning Classifier', icon: 'school' },
        Frozen: { label: 'Static Classifier', icon: 'auto_graph' }
    },
    Detection: {
        Learning: { label: 'Detector', icon: 'fit_screen' },
        Custom: { label: 'Detector', icon: 'fit_screen' }
    }
};
export var BrainExportType;
(function (BrainExportType) {
    BrainExportType["BrainBuilder"] = "brainbuilder";
    BrainExportType["Sony"] = "sony";
})(BrainExportType || (BrainExportType = {}));
var BrainProvider = /** @class */ (function (_super) {
    __extends(BrainProvider, _super);
    function BrainProvider(api, classProvider, downloadProvider, trackableJobProvider, translate) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.classProvider = classProvider;
        _this.downloadProvider = downloadProvider;
        _this.trackableJobProvider = trackableJobProvider;
        _this.translate = translate;
        _this.brains = [];
        _this.training = false;
        _this.predicting = false;
        _this.DIRTY_WARNING = 'Brain is out-of-sync with dataset classes or tagged images.  Retraining your brain is highly recommended.';
        return _this;
    }
    /**
     * Gets n brains
     * @param limit: The number of brains you want
     * Leave this blank to get all brains
     */
    BrainProvider.prototype.getBrains = function (limit) {
        if (limit === void 0) { limit = this.brains.length; }
        return this.brains.slice(0, limit);
    };
    /**
     * Fetches the latest brain listings from BrainBank
     */
    BrainProvider.prototype.fetchLatestBrains = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var latestBrains, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.ensureDependenciesLoaded([this.classProvider])];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.api.get('brains')];
                    case 2:
                        latestBrains = _a.sent();
                        // calculate the total # of polygons in a brain
                        this.brains = latestBrains.message.brains.map(function (obj) {
                            var brain = Object.assign(new Brain(), obj);
                            var numClasses = Object.keys(brain.classStats).length;
                            // Let's calculate this once so everything can use it as a toggle
                            brain.ready = brain.numPolygons >= numClasses * _this.classProvider.THRESHOLD;
                            brain.requiredPolygons = numClasses * _this.classProvider.THRESHOLD;
                            return brain;
                        });
                        return [2 /*return*/, this.brains];
                    case 3:
                        e_1 = _a.sent();
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BrainProvider.prototype.load = function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.ensureLoaded(function () { return _this.fetchLatestBrains(); }, force)];
            });
        });
    };
    /**
     * Removes brain information for the user
     */
    BrainProvider.prototype.resetInfo = function () {
        this.brains = [];
        _super.prototype.resetInfo.call(this);
    };
    /**
     * Creates a new brain and adds it to local brains
     * @param name: The name of new brain
     * @return returns the new created brain
     */
    BrainProvider.prototype.createBrain = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var brainResp, brain, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post('brains', { name: name })];
                    case 1:
                        brainResp = _a.sent();
                        brain = brainResp.message;
                        brain.numPolygons = 0;
                        // add brain to the existing brain list
                        this.brains.push(brain);
                        return [2 /*return*/, brain];
                    case 2:
                        e_2 = _a.sent();
                        throw e_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets active brains name
     * @return {Brain} name of active brain(first for now)
     */
    BrainProvider.prototype.getActiveBrain = function () {
        return this.brains !== null && this.brains.length > 0 ? this.brains[0] : null;
    };
    BrainProvider.prototype.hasActiveBrain = function () {
        return this.brains.length > 0;
    };
    /**
     * Merge the user's classes with the active brain to create a
     * merged object that has properties of both
     *
     * @param {Brain} brain
     * @param {boolean} sorted
     */
    BrainProvider.prototype.getBrainClasses = function (brain, sorted) {
        var _this = this;
        // First find only classes that exist for this brain
        // Then combine them into a single BrainClass object
        var brainClasses = this.classProvider
            .getClasses()
            .filter(function (classObj) { return brain.classStats[classObj.id]; })
            .map(function (classObj) {
            var brainClass = new BrainClass();
            brainClass.name = classObj.name;
            brainClass.color = classObj.color;
            brainClass.numPolygons = brain.classStats[classObj.id].numPolygons;
            brainClass.accuracy = brain.classStats[classObj.id].accuracy;
            brainClass.ready = brainClass.numPolygons >= _this.classProvider.THRESHOLD;
            return brainClass;
        });
        if (sorted) {
            brainClasses.sort(function (a, b) {
                if (a.numPolygons < b.numPolygons) {
                    return 1;
                }
                if (a.numPolygons > b.numPolygons) {
                    return -1;
                }
                return 0;
            });
        }
        return brainClasses;
    };
    /**
     * Return the number of classes associated with the brain that include trained images
     */
    BrainProvider.prototype.getNumTrainedClasses = function (brainDetails) {
        var numTrainedClasses = 0;
        for (var _i = 0, _a = brainDetails.classes; _i < _a.length; _i++) {
            var brainClass = _a[_i];
            if (brainClass.numTrainedPolygons > 0) {
                numTrainedClasses++;
            }
        }
        return numTrainedClasses;
    };
    BrainProvider.prototype.hasBrain = function () {
        return this.brains.length > 0;
    };
    /**
     * Keeps track of whether the brain is currently training or not
     */
    BrainProvider.prototype.isTraining = function () {
        return this.training;
    };
    /**
     * Keeps track of whether the brain is currently training or not
     */
    BrainProvider.prototype.isPredicting = function () {
        return this.predicting;
    };
    /**
     * Train the brain
     * @param {Brain} brain
     * @param {string} imageID
     */
    BrainProvider.prototype.train = function (brain, imageID) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.training = true;
                        return [4 /*yield*/, this.api.post("brains/" + brain.brainIdentifier + "/train", {
                                imageIdentifiers: [imageID]
                            })];
                    case 1:
                        _a.sent();
                        this.training = false;
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        this.training = false;
                        throw err_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BrainProvider.prototype.predict = function (brain, imageID) {
        return __awaiter(this, void 0, void 0, function () {
            var result, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.predicting = true;
                        return [4 /*yield*/, this.api.post("brains/" + brain.brainIdentifier + "/predict", {
                                imageIdentifiers: [imageID]
                            })];
                    case 1:
                        result = _a.sent();
                        this.predicting = false;
                        return [2 /*return*/, result.message];
                    case 2:
                        err_2 = _a.sent();
                        this.predicting = false;
                        throw err_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BrainProvider.prototype.formatAccuracy = function (accuracy) {
        return Math.round(accuracy * 100) + "%";
    };
    BrainProvider.prototype.getBrainEnvironments = function (id, denormalizeROI) {
        if (denormalizeROI === void 0) { denormalizeROI = false; }
        return __awaiter(this, void 0, void 0, function () {
            var brainEnvs, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get("brains/" + id + "/environments?&denormalizeROI=" + denormalizeROI + "&environment[]=current&environment[]=staging&environment[]=production")];
                    case 1:
                        brainEnvs = _a.sent();
                        return [2 /*return*/, brainEnvs.message];
                    case 2:
                        err_3 = _a.sent();
                        throw err_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BrainProvider.prototype.getSingleBrainEnvironment = function (id, environment) {
        return __awaiter(this, void 0, void 0, function () {
            var brainEnvs, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get("brains/" + id + "/environments?environment=" + environment)];
                    case 1:
                        brainEnvs = _a.sent();
                        return [2 /*return*/, brainEnvs.message];
                    case 2:
                        err_4 = _a.sent();
                        throw err_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BrainProvider.prototype.getCurrentBrainDetails = function (id, brainVersionType, denormalizeROI) {
        if (brainVersionType === void 0) { brainVersionType = BrainVersionType.Learning; }
        if (denormalizeROI === void 0) { denormalizeROI = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var brainEnvs, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.debounce(id + "/environments?brainVersionType=" + brainVersionType + "&denormalizeROI=" + denormalizeROI, function () {
                                return _this.api.get("brains/" + id + "/environments?brainVersionType=" + brainVersionType + "&environment[]=current&denormalizeROI=" + denormalizeROI);
                            }, 250)];
                    case 1:
                        brainEnvs = _a.sent();
                        return [2 /*return*/, brainEnvs.message.current];
                    case 2:
                        err_5 = _a.sent();
                        throw err_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BrainProvider.prototype.extractROIDataFromBrain = function (brainDetails) {
        if (brainDetails.roiX1 === null ||
            brainDetails.roiX2 === null ||
            brainDetails.roiY1 === null ||
            brainDetails.roiY2 === null) {
            return null;
        }
        else {
            return {
                x1: brainDetails.roiX1,
                x2: brainDetails.roiX2,
                y1: brainDetails.roiY1,
                y2: brainDetails.roiY2
            };
        }
    };
    BrainProvider.prototype.promote = function (to, from, id, brainVersionType) {
        if (brainVersionType === void 0) { brainVersionType = BrainVersionType.Learning; }
        return __awaiter(this, void 0, void 0, function () {
            var url, response, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        url = "brains/" + id + "/promote";
                        if (brainVersionType && from == BrainEnvironmentName.Current) {
                            url += "?brainVersionType=" + brainVersionType;
                        }
                        return [4 /*yield*/, this.api.post(url, {
                                to: to,
                                from: from
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_6 = _a.sent();
                        throw err_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BrainProvider.prototype.delete = function (id, env) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.delete("brains/" + id + "/environments/" + env + "/releases")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 2:
                        err_7 = _a.sent();
                        throw err_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BrainProvider.prototype.getExportPathEnd = function (brainExportType) {
        var exportPathEnd = '';
        if (brainExportType == BrainExportType.Sony) {
            exportPathEnd = '/sony';
        }
        return exportPathEnd;
    };
    BrainProvider.prototype.download = function (brainVersionIdentifier, brainExportType) {
        return __awaiter(this, void 0, void 0, function () {
            var pathEnd, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pathEnd = this.getExportPathEnd(brainExportType);
                        return [4 /*yield*/, this.api.post("brain-versions/" + brainVersionIdentifier + "/exports" + pathEnd)];
                    case 1:
                        response = _a.sent();
                        if (!(response.success && response.message.signedUrl)) return [3 /*break*/, 3];
                        console.log("Brain download signed URL: " + response.message.signedUrl);
                        return [4 /*yield*/, this.downloadProvider.download(response.message.signedUrl)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    BrainProvider.prototype.kickOffDownloadJob = function (datasetIdentifier, brainVersionIdentifier, brainExportType) {
        return __awaiter(this, void 0, void 0, function () {
            var pathEnd, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pathEnd = this.getExportPathEnd(brainExportType);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.api.post("brain-versions/" + brainVersionIdentifier + "/exports" + pathEnd)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.trackableJobProvider.restartJobPolling()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        this.trackableJobProvider.notifyJobRequestFailed(datasetIdentifier, JobType.BrainExport);
                        throw error_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BrainProvider.prototype.downloadExportedBrain = function (jobIdentifier, brainVersionIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var jobResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.get("brain-versions/" + brainVersionIdentifier + "/exported-brain/" + jobIdentifier)];
                    case 1:
                        jobResult = _a.sent();
                        if (!(jobResult.success && jobResult.signedUrl)) return [3 /*break*/, 4];
                        console.log("Brain download signed URL: " + jobResult.signedUrl);
                        return [4 /*yield*/, this.downloadProvider.download(jobResult.signedUrl)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.trackableJobProvider.dismiss(jobIdentifier)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BrainProvider.prototype.checkMoreClassesThan = function (classes, target) {
        for (var _i = 0, classes_1 = classes; _i < classes_1.length; _i++) {
            var brainEnvClass = classes_1[_i];
            var currentClass = brainEnvClass;
            var numClassImages = currentClass.numTrainedPolygons + currentClass.numValidationPolygons;
            if (numClassImages < target) {
                return false;
            }
        }
        return true;
    };
    BrainProvider.prototype.checkFewerClassesThan = function (classes, target) {
        if (!classes || classes.length == 0) {
            return true;
        }
        for (var _i = 0, classes_2 = classes; _i < classes_2.length; _i++) {
            var brainEnvClass = classes_2[_i];
            var currentClass = brainEnvClass;
            var numClassImages = currentClass.numTrainedPolygons + currentClass.numValidationPolygons;
            if (numClassImages < target) {
                return true;
            }
        }
        return false;
    };
    BrainProvider.prototype.checkClassAccuraciesGreaterThan = function (classes, target) {
        for (var classI = 0; classI < classes.length; classI++) {
            if (classes[classI].accuracy >= target) {
                return true;
            }
        }
        return false;
    };
    BrainProvider.prototype.checkClassAccuraciesLessThan = function (classes, target) {
        for (var classI = 0; classI < classes.length; classI++) {
            if (classes[classI].accuracy < target) {
                return true;
            }
        }
        return false;
    };
    BrainProvider.prototype.isBrainScoreStillLearning = function (brainDetails) {
        return this.checkFewerClassesThan(brainDetails.classes, 10);
    };
    BrainProvider.prototype.isBrainScoreLow = function (brainDetails) {
        if (this.checkFewerClassesThan(brainDetails.classes, 20)) {
            return true;
        }
        else if (brainDetails.accuracy < 0.8) {
            return true;
        }
        else if (this.checkClassAccuraciesLessThan(brainDetails.classes, 0.7)) {
            return true;
        }
        return false;
    };
    BrainProvider.prototype.isBrainScoreGood = function (brainDetails) {
        if (brainDetails.accuracy < 0.9) {
            return true;
        }
        else if (this.checkClassAccuraciesLessThan(brainDetails.classes, 0.9)) {
            return true;
        }
        else if (this.checkFewerClassesThan(brainDetails.classes, 50)) {
            return true;
        }
        return false;
    };
    BrainProvider.prototype.isBrainScoreGreat = function (brainDetails) {
        if (!(brainDetails.accuracy >= 0.9)) {
            return false;
        }
        else if (!this.checkClassAccuraciesGreaterThan(brainDetails.classes, 0.9)) {
            return false;
        }
        else if (!this.checkMoreClassesThan(brainDetails.classes, 0.5)) {
            return false;
        }
        return true;
    };
    BrainProvider.prototype.getBrainScore = function (brainDetails) {
        if (this.isBrainScoreStillLearning(brainDetails)) {
            return BRAIN_ACCURACY_DESCRIPTORS.STILL_LEARNING;
        }
        else if (this.isBrainScoreLow(brainDetails)) {
            return BRAIN_ACCURACY_DESCRIPTORS.LOW;
        }
        else if (this.isBrainScoreGood(brainDetails)) {
            return BRAIN_ACCURACY_DESCRIPTORS.GOOD;
        }
        else if (this.isBrainScoreGreat(brainDetails)) {
            return BRAIN_ACCURACY_DESCRIPTORS.GREAT;
        }
        else {
            return this.translate.instant('Brain class check error');
        }
    };
    BrainProvider.prototype.getBrainVersionDisplayInfo = function (datasetType, brainVersionType) {
        var datasetInfoMap = BrainVersionDisplayInfoMap[datasetType];
        if (!datasetInfoMap) {
            throw new Error("Invalid dataset type: " + datasetType);
        }
        var brainVersionTypeInfo = datasetInfoMap[brainVersionType];
        if (!brainVersionTypeInfo) {
            throw new Error("Invalid brain version type: " + brainVersionType + " for dataset type " + datasetType);
        }
        return brainVersionTypeInfo;
    };
    BrainProvider.prototype.getDetectionThresholdsMetrics = function (datasetIdentifier, detectionThresholdsSpec) {
        return __awaiter(this, void 0, void 0, function () {
            var confidenceThresholdSpec, response, classMetrics, className, metrics;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        confidenceThresholdSpec = encodeURIComponent(JSON.stringify(detectionThresholdsSpec.confidenceThresholdSpec));
                        return [4 /*yield*/, this.api.get("datasets/" + datasetIdentifier + "/detection-thresholds/metrics?confidenceThresholdSpec=" + confidenceThresholdSpec + "&iouThreshold=" + detectionThresholdsSpec.iouThreshold)];
                    case 1:
                        response = _a.sent();
                        classMetrics = {};
                        for (className in response.message.classMetrics) {
                            metrics = response.message.classMetrics[className];
                            classMetrics[className] = {
                                precision: metrics.precision,
                                recall: metrics.recall
                            };
                        }
                        return [2 /*return*/, {
                                averagePrecision: response.message.averagePrecision,
                                averageRecall: response.message.averageRecall,
                                miapVOC: response.message.miapVOC,
                                miapCOCO: response.message.miapCOCO,
                                classMetrics: classMetrics
                            }];
                }
            });
        });
    };
    BrainProvider.prototype.kickoffUpdateDetectionThresholdsJob = function (datasetIdentifier, detectionThresholdsSpec) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.put("datasets/" + datasetIdentifier + "/detection-thresholds", {
                            confidenceThresholdSpec: detectionThresholdsSpec.confidenceThresholdSpec,
                            iouThreshold: detectionThresholdsSpec.iouThreshold,
                            runAsJob: true
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.jobIdentifier];
                }
            });
        });
    };
    /**
     * Call the endpoint to persist hifi pixel parameters
     * This is run as an async job in the back-end so it will now return pretty much immediately with a jobIdentifier
     * It will be up to us to poll the job state
     */
    BrainProvider.prototype.kickoffSaveHiFiPixelParametersJob = function (datasetIdentifier, pixelThreshold, overlayOpacity, overlayColor) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/hifi-pixel-parameters?runAsJob=true", {
                            pixelThreshold: pixelThreshold,
                            overlayOpacity: overlayOpacity,
                            overlayColor: overlayColor.replace('#', '')
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.jobIdentifier];
                }
            });
        });
    };
    BrainProvider.prototype.getFilteredDetectionPredictions = function (predictions, confidenceThresholdSpec) {
        var _this = this;
        return predictions.filter(function (p) {
            return _this.satisfiesConfidenceThreshold(confidenceThresholdSpec, p.classObject.name, p.confidence);
        });
    };
    BrainProvider.prototype.getConfidenceThreshold = function (confidenceThresholdSpec, className) {
        if (confidenceThresholdSpec.classes !== undefined && confidenceThresholdSpec.classes[className]) {
            return confidenceThresholdSpec.classes[className];
        }
        // Fall back to overall if a class threshold isn't defined
        if (confidenceThresholdSpec.overall !== undefined) {
            return confidenceThresholdSpec.overall;
        }
        console.log("Cannot find a valid confidence threshold spec for class " + className);
        return 0.5;
    };
    /**
     * Determines whether the provided confidence is high enough compared to what is required
     */
    BrainProvider.prototype.satisfiesConfidenceThreshold = function (confidenceThresholdSpec, className, confidence) {
        var confidenceThreshold = this.getConfidenceThreshold(confidenceThresholdSpec, className);
        return confidence >= confidenceThreshold;
    };
    BrainProvider.prototype.getDetectionThresholdsSpec = function (confidenceThreshold, editingPerClass, classThresholds, iouThreshold) {
        var confidenceThresholdSpec = {
            overall: confidenceThreshold
        };
        if (editingPerClass) {
            confidenceThresholdSpec.classes = {};
            for (var _i = 0, classThresholds_1 = classThresholds; _i < classThresholds_1.length; _i++) {
                var obj = classThresholds_1[_i];
                confidenceThresholdSpec.classes[obj.name] = obj.confidenceThreshold;
            }
        }
        return {
            iouThreshold: iouThreshold,
            confidenceThresholdSpec: confidenceThresholdSpec
        };
    };
    BrainProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API,
            ClassProvider,
            DownloadProvider,
            TrackableJobProvider,
            TranslateService])
    ], BrainProvider);
    return BrainProvider;
}(BaseProvider));
export { BrainProvider };
//# sourceMappingURL=brain.js.map


// WEBPACK FOOTER //
// ./src/providers/brain.ts.pre-build-optimizer.js